import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "ReferralsFilters",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const {
  getReferralsFilters,
  getReferralsFiltersError,
  getReferralsFiltersSuccess,
} = slice.actions;

reducerRegistry.register("referralsFilters", reducer);
